// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Do not write any CSS in here, add it to the appropriate module or make a new one and import it here. */

@charset 'UTF-8';

html {
  box-sizing: border-box;
  color: #333;
  letter-spacing: 0.05em;
  /*height:  100vh;*/
  height: 100%;
  background: #000000;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  margin: 0;
  /*overflow-x: hidden;*/
  overflow: auto;
}

* {
  box-sizing: inherit;
}

body {
  margin: 0;
  display: flex;
}

.primary-layout,
.unauthorized-layout {
  margin: 1em;
}

h1 {
  font-size: 1.3em;
  margin: 0;
}

a {
  text-decoration: none;
  color: blue;
}

button {
  border: none;
  border-radius: 0.3em;
  padding: 0.5em 1em;
  cursor: pointer;
  outline: 0;
  font-size: 15pt;
}

button:focus {
  /*  background-color: #3e8d3e; */
  cursor: pointer;
}

button.outline {
  border: 1px solid #999;
/*   background-color: #fff; */
  color: #555;
}

.button-width-150 {
    width:  150px;
}

/*welcome page for cloak secure transfer*/
/*
.clk-primary-page {
  height: 100vh;
  width: 100vw;
  top:0px;
  left:0px;
  background-color: transparent;
}
*/
.clk-primary-page {
  display: flex;
  flex-direction: column;
  /*min-height: 100vh;*/
  height: 100vh;
  width: 100vw;
  top:0px;
  left:0px;
  background-color: transparent;
}

.clk-primary-menu-bar-logo {
  width: 100px;
  height: 48px;
/*   padding-top:  10px;
  padding-left: 10px; */
  margin-left: 25px;
  margin-top: 10px;
}

.div {
  display: flex;
}

/*
.clk-primary-layout-div {
  width: 100%;
  background: transparent;
  height: calc(100vh - 100px);
}
*/
.clk-primary-layout-div {
  margin-top: 64px; /* Adjust height to match your header */
  margin-bottom: 56px; /* Adjust height to match your footer */
  /*width: 100%;*/
  background: transparent;
  /*flex: 1;*/
  overflow-y: auto;
}

.clk-primary-console-div {
  height: 500px;
  width: 500px;
  position: absolute;
  background: transparent;
  transition: width 0.2s ease;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  z-index: 10;
}

.clk-primary-qr-div {
  height: 400px;
  width: 500px;
  position: absolute;
  background: transparent;
  transition: width 0.2s ease;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  z-index: 10;
}

.clk-primary-join-div {
  height: 300px;
  width: 500px;
  position: absolute;
  background: transparent;
  transition: width 0.2s ease;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  z-index: 10;
}

@media only screen and (max-width: 500px) {
  div.clk-primary-console-div {
    width: 100vw;
  }
}

@media only screen and (max-width: 500px) {
  div.clk-primary-qr-div {
    width: 100vw;
  }
}

@media only screen and (max-width: 800px) {
  div.clk-primary-layout-div {
    height: calc(100vh - 70px);
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

@media only screen and (max-height: 500px) {
  .clk-primary-console-div {
    width: 500px;
    height: 500px;
    position: relative;
    top: unset;
    transform: none;
    left: 12px;
  }

  .clk-primary-console {
    width: 300px;
    height: 500px;
    top: unset;
    left: unset;
    transform: none;
    margin: 20px auto;
    padding: 20px 10px;
  }

  .clk-primary-qr {
    background-color: #fff;
    width: 300px;
    height: 400px;
    position: relative;
    border-radius: 20px;
    top: unset;
    left: 12px;
    transform: none;
  }
}

.clk-snack-bar {
  height: 60px;
  width: 300px;
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  top: -64px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: #a6a6a6;
  z-index: 10;
}

.clk-snack-bar-inner-div {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.clk-primary-console {
  background-color: #fff;
  height: 500px;
  width: 300px;
  position: absolute;
  border-radius: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.clk-primary-new-header {
  background-color: #fff;
  height: 112px;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  position: absolute;
  border-radius: 20px;
  top: 54px;
  left: 0%;
  padding: 32px;
  text-align: center;
}

.clk-primary-new-header-title {
  font-size: 20px;
}

.clk-primary-new-tryitnow {
  background-color: rgba(255, 255, 255, 0.5);;
  height: 505px;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  position: absolute;
  border-radius: 20px;
  top: 175px;
  left: 0%;
}

.new-step-header {
  position: absolute;
  padding: 20px 32px;
  font-weight: bold;
  z-index: 10;
}

.new-step-content {
  position: absolute;
  padding-top: 60px;
  padding-left: 32px;
  padding-right: 24px;
  font-weight: normal;
  z-index: 10;
}

.new-step-img {
  margin-left: 0%;
  margin-right: 0%;
  width: 243px;
}

.learn-more-img {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-width: 1080px;
}

.learn-more {
  padding-left: 28px;
  padding-top: 20px;
  position:absolute;
}

.clk-primary-new-step1 {
  background-color: #fff;
  height: 400px;
  width: 300px;
  position: relative;
  border-radius: 20px;
  top: 50px;
  left: 50px;
}

.clk-primary-new-step2 {
  background-color: #fff;
  height: 400px;
  width: 300px;
  position: relative;
  border-radius: 20px;
  top: 50px;
  left: 25px;
}

.clk-primary-new-step3 {
  background-color: #fff;
  height: 400px;
  width: 300px;
  position: relative;
  border-radius: 20px;
  top: 50px;
  left: 25px;
}

.clk-primary-new-get-started {
  background-color: #fff;
  height: 400px;
  width: 480px;
  position: relative;
  border-radius: 20px;
  top: 50px;
  left: 20%;
}

.clk-primary-new-signup {
  background-color: #fff;
  height: 400px;
  width: 300px;
  position: relative;
  border-radius: 20px;
  top: 53px;
  left: 50%;
}

.clk-primary-new-learnmore {
  background-color: #fff;
  height: 380px;
  width: 100%;
  padding-left: 10%;
  padding-right: 10%;
  position: relative;
  border-radius: 20px;
  top: 640px;
  left: 0%;
}

.clk-new-landing-page-div {
  width:100%;
  height:100%;
  align-items: center;
}

.table-landing-page {
  height: 100%;
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin: 0 auto; /* or margin: 0 auto 0 auto */
}

.cloak-iframe {
  padding-top: 54px;
  width: 100%;
  height: 100%;
}


.clk-primary-qr {
  background-color: #fff;
  height: 400px;
  width: 300px;
  position: absolute;
  border-radius: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.clk-primary-join {
  background-color: #fff;
  height: 300px;
  width: 300px;
  position: absolute;
  border-radius: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.clk-box-shadow {
  -webkit-box-shadow: 0px 0px 10px -1px #444444;
  -moz-box-shadow: 0px 0px 10px -1px #444444;
  box-shadow: 0px 0px 10px -1px  #444444;
}

.clk-login-div::before {
  content: "";
  display: inline-block;
  height: 32px;
  width: 300px;
}

.clk-login-div {
  background: transparent;
  width: 300px;
}

.clk-signup-div::before {
  content: "";
  display: inline-block;
  height: 32px;
  width: 300px;
}

.clk-signup-div {
  background: transparent;
  width: 300px;
}

.clk-main-title-div {
  width: 100%;
  position: relative;
  /* padding-left: 25px; */
  background: transparent;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.clk-main-title-text {
  width: 100%;
  text-align: center;
  color:  #666;
  font-size: 16px;
}

.clk-main-normal1-text {
  width: 100%;
  text-align: center;
  color:  #666;
  font-size: 12px;
  margin-right: 36px;
  margin-left: 36px;
  margin-top: 24px;
  margin-bottom: 0px;
}

.clk-main-normal2-text {
  width: 100%;
  text-align: center;
  color:  #666;
  font-size: 10px;
  margin-right: 36px;
  margin-left: 36px;
  margin-top: 30px;
  margin-bottom: 0px;
}

.clk-main-normal3-text {
  width: 100%;
  text-align: left;
  color:  #666;
  font-size: 12px;
  margin-right: 36px;
  margin-left: 36px;
  margin-top: 12px;
  margin-bottom: 0px;
}

.clk-vert-line {
  height: 20px;
  width:  1px;
  background-color: #ccc;
  margin-right: 5px;
  margin-left: 5px;
}

.clk-verify-user {
  color: #a6a6a6;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.clk-verify-user::before {
  content: "";
  display: inline-block;
  height: 50px;
  width: 300px;
}

.clk-verify-user-button-div {
  text-align: center;
  margin-top: 20px;
}

.clk-verify-user-code-div {
  text-align: center;
  margin:  20px 100px 0px 100px;
  width: 100px;
}

.clk-forgot-password {
  width: 130px;
  height: 16px;
  align-items: center;
  padding-left: 25px;
  margin-top: 10px;
  /* padding-top: 10px; */
  color: #ccc;
  font-size: 10px;
  transition: color 0.5s ease, font-size 0.2s ease-out, width 0.2s ease-out;
  cursor: pointer;
}

.clk-forgot-password:hover {
  color:  #666;
}

.clk-error {
  width:  300px;
  height: 20px;
  padding-left: 0px;
  text-align:  center;
  background-color: transparent;
  margin-top:  7px;
  margin-bottom:  14px;
  color: #f44336;
  font-size: 11px;
}

.clk-error-no-bottom-margin {
  width:  300px;
  height: 20px;
  padding-left: 0px;
  text-align:  center;
  background-color: transparent;
  margin-top:  7px;
  margin-bottom:  0px;
  color: #f44336;
  font-size: 11px;
}

.clk-success-div {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 46px;
}

.clk-success {
  width:  300px;
  height: 20px;
  text-align: center;
  margin-top: 40px;
  color: #1a1a1a;
  font-size: 12px;
}

.clk-long-url-div {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.clk-long-url {
  width:  300px;
  height: 60px;
  text-align: center;
  margin-top: 6px;
  color: #3333ff;
  font-size: 10px;
  word-break: break-all;
  word-wrap: break-word;
}

.clk-oauth-div {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 30px;
}

.clk-oauth-icon-div {
  background-color: transparent;
  position: relative;
  margin: 0 10px 0 10px;
  transition: background-color 0.5s ease;
  text-align: center;
}

.slow {
  transition: display 0.5s ease;
}

.clk-oauth-icon {
  fill: #a6a6a6;
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: fill 0.2s ease;
}

.clk-oauth-icon:hover {
  fill: #1aa3ff;
}

.ReactModalPortal {
    z-index: 20;
}

.clk-modal-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  color:  #b7b7b7;
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  vertical-align: middle;
  z-index: 20;
}

.clk-modal-header {
  width: 100%;
  height: 75px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.clk-modal-header-title{
  width: 100%;
  margin: 25px 0px 0px 25px;
  text-align: left;
}

.clk-modal-close-icon {
  margin-left: calc(100% - 205px);
  width: 100px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right:  10px;
}

.clk-modal-close-btn {
  display: inline-block;
  position: absolute;
  font-size: 14px;
  color: #828282;
  top: 12px;
  right: 12px;
  height: 20px;
  width: 12px;
  padding: 0;
  margin: 0;
  vertical-align: top;
  background-color: Transparent;
  background-repeat:no-repeat;
  border: none;
  cursor:pointer;
  overflow: hidden;
  outline:none;
}

.clk-modal-content-div {
  width:  100%;
  text-align: center;
  color: #a6a6a6;
  vertical-align: middle;
}

.clk-modal-button-div {
  display: flex;
  flex-direction: row;
  position: relative;
  margin-top: 0px;
  justify-content: center;
}

#modal-pseudo-element {
  content: "";
  display: inline-block;
  height: 30px;
  width: 10px;
}

.clk-trans-button {
  background: transparent;
  color: #333;
  border:  0px solid #ffffff;
  position: relative;
}

.clk-trans-button:hover{
  background: transparent;
  color: #111;
  border:  0px solid #ffffff;
}

.clk-modal-button {
  width: 100px;
  height: 30px;
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #1aa3ff;
  border-radius: 5px;
  font-size: 12px;
  position: relative;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  transition: all 0.2s ease
}

.clk-modal-button:hover{
  background: #66c2ff;
  color: #fff;
  border:  1px solid #66c2ff;
}

/* Upgrade page container.
   The shared .clk-primary-console is a fixed 300x500 white box, absolutely centred
   with translate(-50%,-50%), sized for a short login-style form. The plan cards are
   both wider and much taller than that, and an absolutely centred box taller than the
   viewport clips its own top — the user cannot scroll up to reach it. Six other pages
   depend on the fixed box, so the upgrade page opts out with its own modifier instead
   of the base rule being widened: it drops the fixed size and the centring and flows
   normally, letting .clk-primary-layout-div (overflow-y: auto) scroll it.
   Both modifiers are two-class selectors so they also beat the max-height: 500px and
   max-width: 500px overrides further up this file. */
.clk-primary-console-div.clk-upgrade-console-div {
  position: relative;
  width: 100%;
  max-width: 680px;
  height: auto;
  top: unset;
  /* The max-height: 500px (landscape phone) block above nudges this container with
     left: 12px, which would knock the centring off here. */
  left: unset;
  transform: none;
  -webkit-transform: none;
  margin: 24px auto;
}

.clk-primary-console.clk-upgrade-console {
  position: relative;
  width: auto;
  height: auto;
  top: unset;
  left: unset;
  transform: none;
  -webkit-transform: none;
  padding: 28px 32px 32px;
  box-sizing: border-box;
}

/* The other console pages space their title with an inline marginTop: 40. Here the
   spacing lives in the container padding, so the title only needs a gap beneath it. */
.clk-upgrade-console .clk-main-title-div {
  margin-bottom: 20px;
}

/* Plan cards on the upgrade page. One card per sellable KMS plan; the button hands
   off to Stripe checkout in the KMS console. */
.clk-plan-card {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
  text-align: left;
}

.clk-plan-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.clk-plan-price {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.clk-plan-summary {
  font-size: 12px;
  color: #a6a6a6;
  margin-bottom: 12px;
}

/* The shared .clk-modal-button is a fixed 100px, which truncates these labels. */
.clk-plan-card .clk-modal-button {
  width: auto;
  min-width: 160px;
  padding: 0 12px;
}

/* Phones and small tablets. The box goes edge-to-edge (minus a small gutter) rather
   than staying 680px and overflowing horizontally, and the plan CTA goes full width
   so it stays a comfortable tap target. */
@media only screen and (max-width: 700px) {
  .clk-primary-console-div.clk-upgrade-console-div {
    max-width: none;
    width: calc(100vw - 24px);
    margin: 16px auto;
  }

  .clk-primary-console.clk-upgrade-console {
    padding: 24px 16px 24px;
  }

  .clk-plan-card {
    padding: 14px;
  }

  .clk-plan-card .clk-modal-button {
    width: 100%;
    min-width: 0;
    height: 36px;
  }
}

.clk-sol-modal-div{
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 20;
}

.clk-modal-error {
  width:  300px;
  height: 20px;
  padding-left: 0px;
  background-color: transparent;
  margin-top:  30px;
  color: #f44336;
  font-size: 12px;
  text-align: center;
  z-index: 20;
}

.borderless table {
    border-bottom: 0;
}

.borderless td {
    border-top: 0;
    padding: 6px 10px 6px 0;
}

.clk-sol-request-table-div {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 380px;
  /*max-width: 740px;*/
  padding-top: 8px;
  padding-left: 28px;
  padding-right: 10px;
  padding-bottom: 32px;
  width: 90%;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.clk-sol-approval-table-div {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 380px;
  /*max-width: 820px;*/
  padding-top: 8px;
  padding-left: 28px;
  padding-right: 10px;
  padding-bottom: 32px;
  width: 90%;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.clk-sol-close-icon-div {
  width: 50px;
}

.clk-sol-status-icon{
  fill: #fff;
}

.clk-sol-status-rejected-icon {
  stroke: red;
  fill:  #fff;
  stroke-width: 1px;
}

.clk-sol-close-icon-div::before {
  width: 200px;
}

.clk-sol-table-wrapper {
  overflow-x: auto;
  margin-left: 0px;
  margin-right: 0px;
  height: 100%;
  width: 100%;
}

.clk-sol-table-wrapper::-webkit-scrollbar{
  width: 4px;
}

.clk-sol-table-wrapper::-webkit-scrollbar-track{
  background-color: rgba(224, 224, 224, 1);
  border-radius: 2px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
}

.clk-sol-table-wrapper::-webkit-scrollbar-thumb{
  background-color: darkgrey;
  outline: 4px solid #3e3e3e;
  border-radius: 2px;
}

.clk-user-group-wrapper{
  width: 95%;
  margin-top: 5px;
}

.clk-user-group-content{
  margin-top: 5px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.clk-user-group-wrapper::-webkit-scrollbar{
  width: 4px;
}

.clk-user-group-wrapper::-webkit-scrollbar-track{
  background-color: rgba(224, 224, 224, 1);
  border-radius: 2px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
}

.clk-user-group-wrapper::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 4px solid #3e3e3e;
  border-radius: 2px;
}

.clk-sol-no-data-div {
  font-size: 24px;
  color: #a6a6a6;
  width: 100%;
  text-align: center;
  margin-top: 100px;
}

.clk-modal-linear-progress-div {
  margin-top: 40px;
}

.clk-modal-link {
  color: #cccccc !important;
}

.clk-modal-button:hover .clk-modal-link {
  color: #fff !important;
}

.clk-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  z-index: 20;
  /*width: 60vw;*/
  /* height: 500px;  */
}

.clk-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(102, 102, 102, 0.75);
  z-index: 20;
}

.clk-upload-icon-base {
  fill: #ffd633;
  stroke: #666666;
}

.clk-upload-icon-uparrow {
  /* fill: #808080; */
  fill:  #666666;
}

.clk-upload-icon-hover-filter {
  fill: #fff;
  stroke-width: 0;
  opacity: 0.3;
}

.clk-uparrow-icon:hover {
  fill: #666666;
}

.clk-dropzone {
  border:  2px dashed #e6e6e6;
  margin: auto;
  margin-top: 0px;
  width: 250px;
  height: 150px;
  cursor: pointer;
  background: transparent;
  padding:  15px;
}

.clk-dropzone:hover {
  border:  2px dashed #a6a6a6;
  padding:  15px;
}

.clk-dropzone:hover
.clk-upload-icon-hover-filter{
  fill: none;
}

.clk-dropzone-text-icon {
  font-size: 12px;
  color: #a6a6a6;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.clk-file-delete-icon {
  cursor: pointer;
}

.clk-uploaded-file-icon-div {
  margin: auto;
  margin-top: 0px;
  width: 250px;
  height: 150px;
  background: transparent;
  padding: 15px 15px 15px 15px;
}

.clk-uploaded-file-icon {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin:  auto;
  margin-top: 20px;
  font-size: 11px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: #999999
}

.clk-file-download-icon {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.clk-delete-file-icon-div {
  cursor: pointer;
  margin-top:  10px;
  border-radius: 50%;
}

#file-name::before {
  content: "";
  display: inline-block;
  height: 30px;
  width: 5px;
}

#file-size::before {
  content: "";
  display: inline-block;
  height: 20px;
  width: 5px;
}

#form-details {
  width: 95%;
}

#form-details::before {
  content: "";
  display: inline-block;
  height: 0px;
  width: 5px;
  margin-top: 0px;
}

#transfer-details::before {
  content: "";
  display: inline-block;
  height: 10px;
  width: 5px;
  /* margin-top: 30px; */
}

.clk-user-group-icon{
  cursor: default;
}

.clk-user-group-icon:hover{
  cursor: pointer;
}

.clk-required-field-message {
  margin-top:  20px;
  color: #999999;
}

.clk-form-field-wrapper {
  width: 100%;
  position: relative;
  padding-right: 25px;
  padding-left: 25px;
  background: transparent;
  font-size: 12px;
}

.clk-nav-link {
  font-size: 12px;
  text-align: center;
}

.clk-console-logo-text {
  margin-top: 25px;
  padding:  15px;
  width: 300px;
}

#clk-console-logo {
  margin: 0 auto;
  display: block;
}

.clk-qr-code-wrap {
  margin-top: 30px;
  display: flex;
  justify-content: center; /* centers horizontally */
}

.clk-primary-button-2 {
  width: 160px;
  height: 30px;
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #1aa3ff;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.clk-primary-button-2:hover{
  background: #66c2ff;
  color: #fff;
  border:  1px solid #66c2ff;
}

.clk-primary-button-2 :disabled{
  background: #80ccff;
  color: #fff;
  border:  1px solid #80ccff;
  cursor:  default;
}

.clk-primary-button {
  width: 200px;
  height: 30px;
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #1aa3ff;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.clk-primary-button:hover{
  background: #66c2ff;
  color: #fff;
  border:  1px solid #66c2ff;
}

.clk-primary-button:disabled{
  background: #80ccff;
  color: #fff;
  border:  1px solid #80ccff;
  cursor:  default;
}

.clk-primary-button-div {
  position: relative;
  margin-top: 30px;
  text-align: center;
  /* margin-left: 75px; */
}

.clk-primary-dialog-button {
  /* width: 150px; */
  width: 120px;
  height: 30px;
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #1aa3ff;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.clk-primary-dialog-button:hover{
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #66c2ff;
}

.clk-primary-dialog-button:disabled{
  background: #80ccff;
  color: #fff;
  border:  1px solid #80ccff;
  cursor:  default;
}

.clk-primary-dialog-button-div {
  position: relative;
  margin-top: 30px;
  text-align: center;
  /* margin-left: 75px; */
}

.clk-secondary-button {
  width: 80px;
  height: 30px;
  background: transparent;
  color: #1aa3ff;
  border:  0px solid transparent;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.clk-secondary-button:hover{
  background: transparent;
  color: #1aa3ff;
  border:  0px solid transparent;
}

.clk-secondary-button:disabled{
  background: transparent;
  color: #80ccff;
  border:  0px solid transparent;
  cursor:  default;
}

.clk-secondary-button-div {
  position: relative;
  margin-top: 30px;
  text-align: center;
  /* margin-left: 75px; */
}

.clk-secondary-button2 {
  width: 180px;
  height: 30px;
  background: transparent;
  color: #1aa3ff;
  border:  0px solid transparent;
  border-radius: 10px;
  font-size: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.clk-secondary-button2:hover{
  background: transparent;
  color: #1aa3ff;
  border:  0px solid transparent;
}

.clk-secondary-button2:disabled{
  background: transparent;
  color: #80ccff;
  border:  0px solid transparent;
  cursor:  default;
}

.clk-secondary-button2-div {
  position: relative;
  margin-top: 30px;
  text-align: center;
}

.clk-key-icon-div {
  margin: auto;
  margin-top: 10px;
  background: transparent;
  width: 300px;
  text-align: center;
}

.clk-key-options-div {
  margin: auto;
 /*  margin-top: 100px; */
  width: 300px;
  height: 100%;
  background: transparent;
  padding:  15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.clk-key-options-button-div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  color: #a6a6a6;
}

.clk-key-options-button {
  width: 100px;
  height: 30px;
  background: transparent;
  color: #cccccc;
  border:  1px solid #cccccc;
  border-radius: 5px;
  font-size: 12px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}

.clk-key-options-button:hover{
  background: #1aa3ff;
  color: #fff;
  border:  1px solid #1aa3ff;
}

.clk-key-import-div {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.clk-key-options-content-div {
   width: 300px;
}

.clk-key-options-logo-div {
  width:  100%;
  text-align: center;
}

.clk-key-options-logo-div::after {
  content: "";
  display: inline-block;
  height: 20px;
  width: 100%;
}

.clk-terms-and-cond-div {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 5px;
  width: 250px;
  font-size: 10px;
  color: #a6a6a6;
}

.clk-user-manage-key-div {
  width: 100%;
  text-align: center;
  justify-content: center;
  margin-top: 50px;
  font-size: 10px;
  color: #a6a6a6;
  display: flex;
}

.clk-table-centered {
  align-self: center;
  border: 0;
  border-spacing: 0px;
  border-collapse: collapse;
}

.clk-trm-cond-links {
  color: #a6a6a6;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.clk-trm-cond-links:hover {
  color: #666;
}

.clk-back-icon-div {
  margin-left: 25px;
  margin-top: 25px;
  width: 25px;
}

.clk-back-icon-div:hover {
  cursor: pointer;
  width: 25px;
}

.clk-settings-help-div {
  font-size: 12px;
  width: 15px;
  color: #ccc;
  margin: 0 0 0 25px;
}

.clk-settings-help-div:hover {
  color: #666;
  cursor: pointer;
}

input[type="checkbox" i] {
  /*margin: 3px 3px 3px 0px;*/
  margin: 0px 3px 0px 3px;
}

input[type="checkbox" i]:hover {
    cursor: pointer;
}

.active::after {
  content:  "" !important;
}

.active {
  background-color: transparent !important;
  color: #fff;
}

/*
***************************************************************
*                        Settings CSS
***************************************************************
*/

.settingsOptions {
  width: 100%;
  height: 100%;
  margin: auto;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10px;
}

/*
***************************************************************
*                        Footer CSS
***************************************************************
*/

.clk-footer-div {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50px;
  background-color: #0b0b0b;
  opacity: 1.0;
  color: #fff;
  font-size: 12px;
  align-items: center;
  z-index: 1000;
}

.clk-footer {
/*   height: 50px; */
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  margin: auto;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 0;
}

.clk-footer-block {
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 0;
}

.clk-footer-link-separator {
  margin-left: 1px;
  margin-right: 1px;
  align-items: center;
  height: 20px;
  width: 1px;
  background-color: #fff;
  z-index: 0;
}

@media only screen and (max-width: 800px) {
  div.clk-footer {
    flex-direction: column;
    justify-content: center;
  }

  div.clk-footer-link-separator {
    display: none;
  }
  div.clk-footer-div {
    height: 75px;
  }
}

/*
***************************************************************
*                        Menu Bar CSS
***************************************************************
*/


.menu-button-div {
  width:  100px;
}

.app-title-div {
  width: 150px;
  text-align: left;
  color: #ffffff !important;
}

.appTitle {
  color: #5b5b5b !important;
}

.pseudo-div {
  width: calc(100vw - 410px);
  padding-left: 16px;
}

.pseudo-login-div {
  width: calc(100vw - 150px);
  padding-left: 16px;
}

.clk-primary-menu-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #0b0b0b;
  opacity: 1.0;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.clk-primary-menu-bar-link-div {
/*   width: 220px; */
  height: 50px;
  width: 410px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.clk-primary-menu-bar-login-div {
/*   width: 220px; */
  height: 50px;
  width: 300px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.clk-primary-menu-bar-link-separator {
  margin-left: 2px;
  margin-right: 2px;
  margin-top: -2px;
  align-items: center;
  height: 16px;
  width: 1px;
  background-color: #cccccc;
}

.clk-primary-menu-bar-link {
  height: 50px;
  width: 80px;
  color: #bfbfbf;
  cursor: pointer;
  font-size: 14px;
  margin-top: 30px;
}

.clk-primary-menu-bar-link:hover {
  color: #fff;
}

.clk-primary-menu-bar-link-user {
  height: 50px;
  width: 50px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s ease;
  margin-top: 0px;
}

.clk-primary-menu-bar-link-user:hover{
  color: #bfbfbf;
}

.clk-primary-menu-bar-link-badged-user {
  height: 50px;
  width: 50px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s ease;
  margin-top: -7px;
}

.clk-primary-menu-bar-link-badged-user:hover{
  color: #bfbfbf;
}

.clk-primary-menu-bar-link-mobile {
  display: none;
  width: 0;
  margin-left: 290px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s ease;
}

.clk-primary-menu-bar-link-mobile:hover {
  color: #bfbfbf;
}


.clk-primary-menu-link-selected {
  color: #bfbfbf;
}

#link-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px;
  margin: 10px;
}

#spacer {
  flex: 1;
}

@media only screen and (max-width: 300px) {
  div.pseudo-div {
    width: 0px;
  }
}

@media only screen and (max-width: 600px) {
  div.pseudo-div {
    width: calc(100vw - 60px);
  }
  div.clk-primary-menu-bar-link-user {
    display: none;
    width: 0px;
  }
  div.clk-primary-menu-bar-link-badged-user {
    display: none;
    width: 0px;
  }
  div.clk-primary-menu-bar-link-mobile {
    display: inline;
    width: 60px
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,wGAAwG;;AAExG,gBAAgB;;AAEhB;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;EACvD,SAAS;EACT,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB,8BAA8B;EAC5B,WAAW;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA,yCAAyC;AACzC;;;;;;;;CAQC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;uBACuB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;CAMC;AACD;EACE,gBAAgB,EAAE,uCAAuC;EACzD,mBAAmB,EAAE,uCAAuC;EAC5D,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,cAAc,EAAE,6BAA6B;AAC/C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,yEAAyE;EACzE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,uDAAuD;EACvD,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;EACvD;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;;;;;;qDASqD;AACrD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV;2DACyD;EACzD,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;sFACsF;AACtF;EACE,mBAAmB;AACrB;;AAEA;+CAC+C;AAC/C;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;0CAE0C;AAC1C;EACE;IACE,eAAe;IACf,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD;AACF;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;CACb,wBAAwB;EACvB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;GACG,YAAY;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;CAIC;;AAED;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;AAEA;AACA,oBAAoB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;;;;CAIC;;;AAGD;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;AACA,oBAAoB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;AACA,oBAAoB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,eAAe;IACf;EACF;AACF","sourcesContent":["/*Do not write any CSS in here, add it to the appropriate module or make a new one and import it here. */\n\n@charset 'UTF-8';\n\nhtml {\n  box-sizing: border-box;\n  color: #333;\n  letter-spacing: 0.05em;\n  /*height:  100vh;*/\n  height: 100%;\n  background: #000000;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  margin: 0;\n  /*overflow-x: hidden;*/\n  overflow: auto;\n}\n\n* {\n  box-sizing: inherit;\n}\n\nbody {\n  margin: 0;\n  display: flex;\n}\n\n.primary-layout,\n.unauthorized-layout {\n  margin: 1em;\n}\n\nh1 {\n  font-size: 1.3em;\n  margin: 0;\n}\n\na {\n  text-decoration: none;\n  color: blue;\n}\n\nbutton {\n  border: none;\n  border-radius: 0.3em;\n  padding: 0.5em 1em;\n  cursor: pointer;\n  outline: 0;\n  font-size: 15pt;\n}\n\nbutton:focus {\n  /*  background-color: #3e8d3e; */\n  cursor: pointer;\n}\n\nbutton.outline {\n  border: 1px solid #999;\n/*   background-color: #fff; */\n  color: #555;\n}\n\n.button-width-150 {\n    width:  150px;\n}\n\n/*welcome page for cloak secure transfer*/\n/*\n.clk-primary-page {\n  height: 100vh;\n  width: 100vw;\n  top:0px;\n  left:0px;\n  background-color: transparent;\n}\n*/\n.clk-primary-page {\n  display: flex;\n  flex-direction: column;\n  /*min-height: 100vh;*/\n  height: 100vh;\n  width: 100vw;\n  top:0px;\n  left:0px;\n  background-color: transparent;\n}\n\n.clk-primary-menu-bar-logo {\n  width: 100px;\n  height: 48px;\n/*   padding-top:  10px;\n  padding-left: 10px; */\n  margin-left: 25px;\n  margin-top: 10px;\n}\n\n.div {\n  display: flex;\n}\n\n/*\n.clk-primary-layout-div {\n  width: 100%;\n  background: transparent;\n  height: calc(100vh - 100px);\n}\n*/\n.clk-primary-layout-div {\n  margin-top: 64px; /* Adjust height to match your header */\n  margin-bottom: 56px; /* Adjust height to match your footer */\n  /*width: 100%;*/\n  background: transparent;\n  /*flex: 1;*/\n  overflow-y: auto;\n}\n\n.clk-primary-console-div {\n  height: 500px;\n  width: 500px;\n  position: absolute;\n  background: transparent;\n  transition: width 0.2s ease;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  z-index: 10;\n}\n\n.clk-primary-qr-div {\n  height: 400px;\n  width: 500px;\n  position: absolute;\n  background: transparent;\n  transition: width 0.2s ease;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  z-index: 10;\n}\n\n.clk-primary-join-div {\n  height: 300px;\n  width: 500px;\n  position: absolute;\n  background: transparent;\n  transition: width 0.2s ease;\n  top: 50%;\n  transform: translateY(-50%);\n  -webkit-transform: translateY(-50%);\n  z-index: 10;\n}\n\n@media only screen and (max-width: 500px) {\n  div.clk-primary-console-div {\n    width: 100vw;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  div.clk-primary-qr-div {\n    width: 100vw;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  div.clk-primary-layout-div {\n    height: calc(100vh - 70px);\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (max-height: 500px) {\n  .clk-primary-console-div {\n    width: 500px;\n    height: 500px;\n    position: relative;\n    top: unset;\n    transform: none;\n    left: 12px;\n  }\n\n  .clk-primary-console {\n    width: 300px;\n    height: 500px;\n    top: unset;\n    left: unset;\n    transform: none;\n    margin: 20px auto;\n    padding: 20px 10px;\n  }\n\n  .clk-primary-qr {\n    background-color: #fff;\n    width: 300px;\n    height: 400px;\n    position: relative;\n    border-radius: 20px;\n    top: unset;\n    left: 12px;\n    transform: none;\n  }\n}\n\n.clk-snack-bar {\n  height: 60px;\n  width: 300px;\n  background-color: #fff;\n  border-radius: 10px;\n  position: relative;\n  top: -64px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 12px;\n  color: #a6a6a6;\n  z-index: 10;\n}\n\n.clk-snack-bar-inner-div {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.clk-primary-console {\n  background-color: #fff;\n  height: 500px;\n  width: 300px;\n  position: absolute;\n  border-radius: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.clk-primary-new-header {\n  background-color: #fff;\n  height: 112px;\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n  position: absolute;\n  border-radius: 20px;\n  top: 54px;\n  left: 0%;\n  padding: 32px;\n  text-align: center;\n}\n\n.clk-primary-new-header-title {\n  font-size: 20px;\n}\n\n.clk-primary-new-tryitnow {\n  background-color: rgba(255, 255, 255, 0.5);;\n  height: 505px;\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n  position: absolute;\n  border-radius: 20px;\n  top: 175px;\n  left: 0%;\n}\n\n.new-step-header {\n  position: absolute;\n  padding: 20px 32px;\n  font-weight: bold;\n  z-index: 10;\n}\n\n.new-step-content {\n  position: absolute;\n  padding-top: 60px;\n  padding-left: 32px;\n  padding-right: 24px;\n  font-weight: normal;\n  z-index: 10;\n}\n\n.new-step-img {\n  margin-left: 0%;\n  margin-right: 0%;\n  width: 243px;\n}\n\n.learn-more-img {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  max-width: 1080px;\n}\n\n.learn-more {\n  padding-left: 28px;\n  padding-top: 20px;\n  position:absolute;\n}\n\n.clk-primary-new-step1 {\n  background-color: #fff;\n  height: 400px;\n  width: 300px;\n  position: relative;\n  border-radius: 20px;\n  top: 50px;\n  left: 50px;\n}\n\n.clk-primary-new-step2 {\n  background-color: #fff;\n  height: 400px;\n  width: 300px;\n  position: relative;\n  border-radius: 20px;\n  top: 50px;\n  left: 25px;\n}\n\n.clk-primary-new-step3 {\n  background-color: #fff;\n  height: 400px;\n  width: 300px;\n  position: relative;\n  border-radius: 20px;\n  top: 50px;\n  left: 25px;\n}\n\n.clk-primary-new-get-started {\n  background-color: #fff;\n  height: 400px;\n  width: 480px;\n  position: relative;\n  border-radius: 20px;\n  top: 50px;\n  left: 20%;\n}\n\n.clk-primary-new-signup {\n  background-color: #fff;\n  height: 400px;\n  width: 300px;\n  position: relative;\n  border-radius: 20px;\n  top: 53px;\n  left: 50%;\n}\n\n.clk-primary-new-learnmore {\n  background-color: #fff;\n  height: 380px;\n  width: 100%;\n  padding-left: 10%;\n  padding-right: 10%;\n  position: relative;\n  border-radius: 20px;\n  top: 640px;\n  left: 0%;\n}\n\n.clk-new-landing-page-div {\n  width:100%;\n  height:100%;\n  align-items: center;\n}\n\n.table-landing-page {\n  height: 100%;\n  width: 80%;\n  margin-left: 10%;\n  margin-right: 10%;\n  margin: 0 auto; /* or margin: 0 auto 0 auto */\n}\n\n.cloak-iframe {\n  padding-top: 54px;\n  width: 100%;\n  height: 100%;\n}\n\n\n.clk-primary-qr {\n  background-color: #fff;\n  height: 400px;\n  width: 300px;\n  position: absolute;\n  border-radius: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.clk-primary-join {\n  background-color: #fff;\n  height: 300px;\n  width: 300px;\n  position: absolute;\n  border-radius: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.clk-box-shadow {\n  -webkit-box-shadow: 0px 0px 10px -1px #444444;\n  -moz-box-shadow: 0px 0px 10px -1px #444444;\n  box-shadow: 0px 0px 10px -1px  #444444;\n}\n\n.clk-login-div::before {\n  content: \"\";\n  display: inline-block;\n  height: 32px;\n  width: 300px;\n}\n\n.clk-login-div {\n  background: transparent;\n  width: 300px;\n}\n\n.clk-signup-div::before {\n  content: \"\";\n  display: inline-block;\n  height: 32px;\n  width: 300px;\n}\n\n.clk-signup-div {\n  background: transparent;\n  width: 300px;\n}\n\n.clk-main-title-div {\n  width: 100%;\n  position: relative;\n  /* padding-left: 25px; */\n  background: transparent;\n  font-size: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.clk-main-title-text {\n  width: 100%;\n  text-align: center;\n  color:  #666;\n  font-size: 16px;\n}\n\n.clk-main-normal1-text {\n  width: 100%;\n  text-align: center;\n  color:  #666;\n  font-size: 12px;\n  margin-right: 36px;\n  margin-left: 36px;\n  margin-top: 24px;\n  margin-bottom: 0px;\n}\n\n.clk-main-normal2-text {\n  width: 100%;\n  text-align: center;\n  color:  #666;\n  font-size: 10px;\n  margin-right: 36px;\n  margin-left: 36px;\n  margin-top: 30px;\n  margin-bottom: 0px;\n}\n\n.clk-main-normal3-text {\n  width: 100%;\n  text-align: left;\n  color:  #666;\n  font-size: 12px;\n  margin-right: 36px;\n  margin-left: 36px;\n  margin-top: 12px;\n  margin-bottom: 0px;\n}\n\n.clk-vert-line {\n  height: 20px;\n  width:  1px;\n  background-color: #ccc;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.clk-verify-user {\n  color: #a6a6a6;\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.clk-verify-user::before {\n  content: \"\";\n  display: inline-block;\n  height: 50px;\n  width: 300px;\n}\n\n.clk-verify-user-button-div {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.clk-verify-user-code-div {\n  text-align: center;\n  margin:  20px 100px 0px 100px;\n  width: 100px;\n}\n\n.clk-forgot-password {\n  width: 130px;\n  height: 16px;\n  align-items: center;\n  padding-left: 25px;\n  margin-top: 10px;\n  /* padding-top: 10px; */\n  color: #ccc;\n  font-size: 10px;\n  transition: color 0.5s ease, font-size 0.2s ease-out, width 0.2s ease-out;\n  cursor: pointer;\n}\n\n.clk-forgot-password:hover {\n  color:  #666;\n}\n\n.clk-error {\n  width:  300px;\n  height: 20px;\n  padding-left: 0px;\n  text-align:  center;\n  background-color: transparent;\n  margin-top:  7px;\n  margin-bottom:  14px;\n  color: #f44336;\n  font-size: 11px;\n}\n\n.clk-error-no-bottom-margin {\n  width:  300px;\n  height: 20px;\n  padding-left: 0px;\n  text-align:  center;\n  background-color: transparent;\n  margin-top:  7px;\n  margin-bottom:  0px;\n  color: #f44336;\n  font-size: 11px;\n}\n\n.clk-success-div {\n  width: 300px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 46px;\n}\n\n.clk-success {\n  width:  300px;\n  height: 20px;\n  text-align: center;\n  margin-top: 40px;\n  color: #1a1a1a;\n  font-size: 12px;\n}\n\n.clk-long-url-div {\n  width: 300px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.clk-long-url {\n  width:  300px;\n  height: 60px;\n  text-align: center;\n  margin-top: 6px;\n  color: #3333ff;\n  font-size: 10px;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n\n.clk-oauth-div {\n  width: 300px;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 30px;\n}\n\n.clk-oauth-icon-div {\n  background-color: transparent;\n  position: relative;\n  margin: 0 10px 0 10px;\n  transition: background-color 0.5s ease;\n  text-align: center;\n}\n\n.slow {\n  transition: display 0.5s ease;\n}\n\n.clk-oauth-icon {\n  fill: #a6a6a6;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  transition: fill 0.2s ease;\n}\n\n.clk-oauth-icon:hover {\n  fill: #1aa3ff;\n}\n\n.ReactModalPortal {\n    z-index: 20;\n}\n\n.clk-modal-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color:  #b7b7b7;\n  font-size: 12px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  vertical-align: middle;\n  z-index: 20;\n}\n\n.clk-modal-header {\n  width: 100%;\n  height: 75px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.clk-modal-header-title{\n  width: 100%;\n  margin: 25px 0px 0px 25px;\n  text-align: left;\n}\n\n.clk-modal-close-icon {\n  margin-left: calc(100% - 205px);\n  width: 100px;\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-right:  10px;\n}\n\n.clk-modal-close-btn {\n  display: inline-block;\n  position: absolute;\n  font-size: 14px;\n  color: #828282;\n  top: 12px;\n  right: 12px;\n  height: 20px;\n  width: 12px;\n  padding: 0;\n  margin: 0;\n  vertical-align: top;\n  background-color: Transparent;\n  background-repeat:no-repeat;\n  border: none;\n  cursor:pointer;\n  overflow: hidden;\n  outline:none;\n}\n\n.clk-modal-content-div {\n  width:  100%;\n  text-align: center;\n  color: #a6a6a6;\n  vertical-align: middle;\n}\n\n.clk-modal-button-div {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  margin-top: 0px;\n  justify-content: center;\n}\n\n#modal-pseudo-element {\n  content: \"\";\n  display: inline-block;\n  height: 30px;\n  width: 10px;\n}\n\n.clk-trans-button {\n  background: transparent;\n  color: #333;\n  border:  0px solid #ffffff;\n  position: relative;\n}\n\n.clk-trans-button:hover{\n  background: transparent;\n  color: #111;\n  border:  0px solid #ffffff;\n}\n\n.clk-modal-button {\n  width: 100px;\n  height: 30px;\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #1aa3ff;\n  border-radius: 5px;\n  font-size: 12px;\n  position: relative;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  transition: all 0.2s ease\n}\n\n.clk-modal-button:hover{\n  background: #66c2ff;\n  color: #fff;\n  border:  1px solid #66c2ff;\n}\n\n/* Upgrade page container.\n   The shared .clk-primary-console is a fixed 300x500 white box, absolutely centred\n   with translate(-50%,-50%), sized for a short login-style form. The plan cards are\n   both wider and much taller than that, and an absolutely centred box taller than the\n   viewport clips its own top — the user cannot scroll up to reach it. Six other pages\n   depend on the fixed box, so the upgrade page opts out with its own modifier instead\n   of the base rule being widened: it drops the fixed size and the centring and flows\n   normally, letting .clk-primary-layout-div (overflow-y: auto) scroll it.\n   Both modifiers are two-class selectors so they also beat the max-height: 500px and\n   max-width: 500px overrides further up this file. */\n.clk-primary-console-div.clk-upgrade-console-div {\n  position: relative;\n  width: 100%;\n  max-width: 680px;\n  height: auto;\n  top: unset;\n  /* The max-height: 500px (landscape phone) block above nudges this container with\n     left: 12px, which would knock the centring off here. */\n  left: unset;\n  transform: none;\n  -webkit-transform: none;\n  margin: 24px auto;\n}\n\n.clk-primary-console.clk-upgrade-console {\n  position: relative;\n  width: auto;\n  height: auto;\n  top: unset;\n  left: unset;\n  transform: none;\n  -webkit-transform: none;\n  padding: 28px 32px 32px;\n  box-sizing: border-box;\n}\n\n/* The other console pages space their title with an inline marginTop: 40. Here the\n   spacing lives in the container padding, so the title only needs a gap beneath it. */\n.clk-upgrade-console .clk-main-title-div {\n  margin-bottom: 20px;\n}\n\n/* Plan cards on the upgrade page. One card per sellable KMS plan; the button hands\n   off to Stripe checkout in the KMS console. */\n.clk-plan-card {\n  border: 1px solid #d9d9d9;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.clk-plan-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.clk-plan-price {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.clk-plan-summary {\n  font-size: 12px;\n  color: #a6a6a6;\n  margin-bottom: 12px;\n}\n\n/* The shared .clk-modal-button is a fixed 100px, which truncates these labels. */\n.clk-plan-card .clk-modal-button {\n  width: auto;\n  min-width: 160px;\n  padding: 0 12px;\n}\n\n/* Phones and small tablets. The box goes edge-to-edge (minus a small gutter) rather\n   than staying 680px and overflowing horizontally, and the plan CTA goes full width\n   so it stays a comfortable tap target. */\n@media only screen and (max-width: 700px) {\n  .clk-primary-console-div.clk-upgrade-console-div {\n    max-width: none;\n    width: calc(100vw - 24px);\n    margin: 16px auto;\n  }\n\n  .clk-primary-console.clk-upgrade-console {\n    padding: 24px 16px 24px;\n  }\n\n  .clk-plan-card {\n    padding: 14px;\n  }\n\n  .clk-plan-card .clk-modal-button {\n    width: 100%;\n    min-width: 0;\n    height: 36px;\n  }\n}\n\n.clk-sol-modal-div{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 20;\n}\n\n.clk-modal-error {\n  width:  300px;\n  height: 20px;\n  padding-left: 0px;\n  background-color: transparent;\n  margin-top:  30px;\n  color: #f44336;\n  font-size: 12px;\n  text-align: center;\n  z-index: 20;\n}\n\n.borderless table {\n    border-bottom: 0;\n}\n\n.borderless td {\n    border-top: 0;\n    padding: 6px 10px 6px 0;\n}\n\n.clk-sol-request-table-div {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 380px;\n  /*max-width: 740px;*/\n  padding-top: 8px;\n  padding-left: 28px;\n  padding-right: 10px;\n  padding-bottom: 32px;\n  width: 90%;\n  border-radius: 10px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.clk-sol-approval-table-div {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 380px;\n  /*max-width: 820px;*/\n  padding-top: 8px;\n  padding-left: 28px;\n  padding-right: 10px;\n  padding-bottom: 32px;\n  width: 90%;\n  border-radius: 10px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.clk-sol-close-icon-div {\n  width: 50px;\n}\n\n.clk-sol-status-icon{\n  fill: #fff;\n}\n\n.clk-sol-status-rejected-icon {\n  stroke: red;\n  fill:  #fff;\n  stroke-width: 1px;\n}\n\n.clk-sol-close-icon-div::before {\n  width: 200px;\n}\n\n.clk-sol-table-wrapper {\n  overflow-x: auto;\n  margin-left: 0px;\n  margin-right: 0px;\n  height: 100%;\n  width: 100%;\n}\n\n.clk-sol-table-wrapper::-webkit-scrollbar{\n  width: 4px;\n}\n\n.clk-sol-table-wrapper::-webkit-scrollbar-track{\n  background-color: rgba(224, 224, 224, 1);\n  border-radius: 2px;\n  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */\n}\n\n.clk-sol-table-wrapper::-webkit-scrollbar-thumb{\n  background-color: darkgrey;\n  outline: 4px solid #3e3e3e;\n  border-radius: 2px;\n}\n\n.clk-user-group-wrapper{\n  width: 95%;\n  margin-top: 5px;\n}\n\n.clk-user-group-content{\n  margin-top: 5px;\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.clk-user-group-wrapper::-webkit-scrollbar{\n  width: 4px;\n}\n\n.clk-user-group-wrapper::-webkit-scrollbar-track{\n  background-color: rgba(224, 224, 224, 1);\n  border-radius: 2px;\n  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */\n}\n\n.clk-user-group-wrapper::-webkit-scrollbar-thumb {\n  background-color: darkgrey;\n  outline: 4px solid #3e3e3e;\n  border-radius: 2px;\n}\n\n.clk-sol-no-data-div {\n  font-size: 24px;\n  color: #a6a6a6;\n  width: 100%;\n  text-align: center;\n  margin-top: 100px;\n}\n\n.clk-modal-linear-progress-div {\n  margin-top: 40px;\n}\n\n.clk-modal-link {\n  color: #cccccc !important;\n}\n\n.clk-modal-button:hover .clk-modal-link {\n  color: #fff !important;\n}\n\n.clk-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  right: auto;\n  bottom: auto;\n  margin-right: -50%;\n  transform: translate(-50%, -50%);\n  background-color: #fff;\n  z-index: 20;\n  /*width: 60vw;*/\n  /* height: 500px;  */\n}\n\n.clk-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(102, 102, 102, 0.75);\n  z-index: 20;\n}\n\n.clk-upload-icon-base {\n  fill: #ffd633;\n  stroke: #666666;\n}\n\n.clk-upload-icon-uparrow {\n  /* fill: #808080; */\n  fill:  #666666;\n}\n\n.clk-upload-icon-hover-filter {\n  fill: #fff;\n  stroke-width: 0;\n  opacity: 0.3;\n}\n\n.clk-uparrow-icon:hover {\n  fill: #666666;\n}\n\n.clk-dropzone {\n  border:  2px dashed #e6e6e6;\n  margin: auto;\n  margin-top: 0px;\n  width: 250px;\n  height: 150px;\n  cursor: pointer;\n  background: transparent;\n  padding:  15px;\n}\n\n.clk-dropzone:hover {\n  border:  2px dashed #a6a6a6;\n  padding:  15px;\n}\n\n.clk-dropzone:hover\n.clk-upload-icon-hover-filter{\n  fill: none;\n}\n\n.clk-dropzone-text-icon {\n  font-size: 12px;\n  color: #a6a6a6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.clk-file-delete-icon {\n  cursor: pointer;\n}\n\n.clk-uploaded-file-icon-div {\n  margin: auto;\n  margin-top: 0px;\n  width: 250px;\n  height: 150px;\n  background: transparent;\n  padding: 15px 15px 15px 15px;\n}\n\n.clk-uploaded-file-icon {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin:  auto;\n  margin-top: 20px;\n  font-size: 11px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  color: #999999\n}\n\n.clk-file-download-icon {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.clk-delete-file-icon-div {\n  cursor: pointer;\n  margin-top:  10px;\n  border-radius: 50%;\n}\n\n#file-name::before {\n  content: \"\";\n  display: inline-block;\n  height: 30px;\n  width: 5px;\n}\n\n#file-size::before {\n  content: \"\";\n  display: inline-block;\n  height: 20px;\n  width: 5px;\n}\n\n#form-details {\n  width: 95%;\n}\n\n#form-details::before {\n  content: \"\";\n  display: inline-block;\n  height: 0px;\n  width: 5px;\n  margin-top: 0px;\n}\n\n#transfer-details::before {\n  content: \"\";\n  display: inline-block;\n  height: 10px;\n  width: 5px;\n  /* margin-top: 30px; */\n}\n\n.clk-user-group-icon{\n  cursor: default;\n}\n\n.clk-user-group-icon:hover{\n  cursor: pointer;\n}\n\n.clk-required-field-message {\n  margin-top:  20px;\n  color: #999999;\n}\n\n.clk-form-field-wrapper {\n  width: 100%;\n  position: relative;\n  padding-right: 25px;\n  padding-left: 25px;\n  background: transparent;\n  font-size: 12px;\n}\n\n.clk-nav-link {\n  font-size: 12px;\n  text-align: center;\n}\n\n.clk-console-logo-text {\n  margin-top: 25px;\n  padding:  15px;\n  width: 300px;\n}\n\n#clk-console-logo {\n  margin: 0 auto;\n  display: block;\n}\n\n.clk-qr-code-wrap {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center; /* centers horizontally */\n}\n\n.clk-primary-button-2 {\n  width: 160px;\n  height: 30px;\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #1aa3ff;\n  border-radius: 10px;\n  font-size: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.clk-primary-button-2:hover{\n  background: #66c2ff;\n  color: #fff;\n  border:  1px solid #66c2ff;\n}\n\n.clk-primary-button-2 :disabled{\n  background: #80ccff;\n  color: #fff;\n  border:  1px solid #80ccff;\n  cursor:  default;\n}\n\n.clk-primary-button {\n  width: 200px;\n  height: 30px;\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #1aa3ff;\n  border-radius: 10px;\n  font-size: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.clk-primary-button:hover{\n  background: #66c2ff;\n  color: #fff;\n  border:  1px solid #66c2ff;\n}\n\n.clk-primary-button:disabled{\n  background: #80ccff;\n  color: #fff;\n  border:  1px solid #80ccff;\n  cursor:  default;\n}\n\n.clk-primary-button-div {\n  position: relative;\n  margin-top: 30px;\n  text-align: center;\n  /* margin-left: 75px; */\n}\n\n.clk-primary-dialog-button {\n  /* width: 150px; */\n  width: 120px;\n  height: 30px;\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #1aa3ff;\n  border-radius: 10px;\n  font-size: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.clk-primary-dialog-button:hover{\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #66c2ff;\n}\n\n.clk-primary-dialog-button:disabled{\n  background: #80ccff;\n  color: #fff;\n  border:  1px solid #80ccff;\n  cursor:  default;\n}\n\n.clk-primary-dialog-button-div {\n  position: relative;\n  margin-top: 30px;\n  text-align: center;\n  /* margin-left: 75px; */\n}\n\n.clk-secondary-button {\n  width: 80px;\n  height: 30px;\n  background: transparent;\n  color: #1aa3ff;\n  border:  0px solid transparent;\n  border-radius: 10px;\n  font-size: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.clk-secondary-button:hover{\n  background: transparent;\n  color: #1aa3ff;\n  border:  0px solid transparent;\n}\n\n.clk-secondary-button:disabled{\n  background: transparent;\n  color: #80ccff;\n  border:  0px solid transparent;\n  cursor:  default;\n}\n\n.clk-secondary-button-div {\n  position: relative;\n  margin-top: 30px;\n  text-align: center;\n  /* margin-left: 75px; */\n}\n\n.clk-secondary-button2 {\n  width: 180px;\n  height: 30px;\n  background: transparent;\n  color: #1aa3ff;\n  border:  0px solid transparent;\n  border-radius: 10px;\n  font-size: 12px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.clk-secondary-button2:hover{\n  background: transparent;\n  color: #1aa3ff;\n  border:  0px solid transparent;\n}\n\n.clk-secondary-button2:disabled{\n  background: transparent;\n  color: #80ccff;\n  border:  0px solid transparent;\n  cursor:  default;\n}\n\n.clk-secondary-button2-div {\n  position: relative;\n  margin-top: 30px;\n  text-align: center;\n}\n\n.clk-key-icon-div {\n  margin: auto;\n  margin-top: 10px;\n  background: transparent;\n  width: 300px;\n  text-align: center;\n}\n\n.clk-key-options-div {\n  margin: auto;\n /*  margin-top: 100px; */\n  width: 300px;\n  height: 100%;\n  background: transparent;\n  padding:  15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.clk-key-options-button-div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  color: #a6a6a6;\n}\n\n.clk-key-options-button {\n  width: 100px;\n  height: 30px;\n  background: transparent;\n  color: #cccccc;\n  border:  1px solid #cccccc;\n  border-radius: 5px;\n  font-size: 12px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n}\n\n.clk-key-options-button:hover{\n  background: #1aa3ff;\n  color: #fff;\n  border:  1px solid #1aa3ff;\n}\n\n.clk-key-import-div {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.clk-key-options-content-div {\n   width: 300px;\n}\n\n.clk-key-options-logo-div {\n  width:  100%;\n  text-align: center;\n}\n\n.clk-key-options-logo-div::after {\n  content: \"\";\n  display: inline-block;\n  height: 20px;\n  width: 100%;\n}\n\n.clk-terms-and-cond-div {\n  display: flex;\n  flex-direction: row;\n  justify-content: left;\n  margin-left: 25px;\n  margin-right: 25px;\n  margin-top: 5px;\n  width: 250px;\n  font-size: 10px;\n  color: #a6a6a6;\n}\n\n.clk-user-manage-key-div {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  margin-top: 50px;\n  font-size: 10px;\n  color: #a6a6a6;\n  display: flex;\n}\n\n.clk-table-centered {\n  align-self: center;\n  border: 0;\n  border-spacing: 0px;\n  border-collapse: collapse;\n}\n\n.clk-trm-cond-links {\n  color: #a6a6a6;\n  text-decoration: underline;\n  transition: color 0.2s ease;\n}\n\n.clk-trm-cond-links:hover {\n  color: #666;\n}\n\n.clk-back-icon-div {\n  margin-left: 25px;\n  margin-top: 25px;\n  width: 25px;\n}\n\n.clk-back-icon-div:hover {\n  cursor: pointer;\n  width: 25px;\n}\n\n.clk-settings-help-div {\n  font-size: 12px;\n  width: 15px;\n  color: #ccc;\n  margin: 0 0 0 25px;\n}\n\n.clk-settings-help-div:hover {\n  color: #666;\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\" i] {\n  /*margin: 3px 3px 3px 0px;*/\n  margin: 0px 3px 0px 3px;\n}\n\ninput[type=\"checkbox\" i]:hover {\n    cursor: pointer;\n}\n\n.active::after {\n  content:  \"\" !important;\n}\n\n.active {\n  background-color: transparent !important;\n  color: #fff;\n}\n\n/*\n***************************************************************\n*                        Settings CSS\n***************************************************************\n*/\n\n.settingsOptions {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-top: 10px;\n}\n\n/*\n***************************************************************\n*                        Footer CSS\n***************************************************************\n*/\n\n.clk-footer-div {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 50px;\n  background-color: #0b0b0b;\n  opacity: 1.0;\n  color: #fff;\n  font-size: 12px;\n  align-items: center;\n  z-index: 1000;\n}\n\n.clk-footer {\n/*   height: 50px; */\n  width: 100%;\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  margin: auto;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  z-index: 0;\n}\n\n.clk-footer-block {\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  z-index: 0;\n}\n\n.clk-footer-link-separator {\n  margin-left: 1px;\n  margin-right: 1px;\n  align-items: center;\n  height: 20px;\n  width: 1px;\n  background-color: #fff;\n  z-index: 0;\n}\n\n@media only screen and (max-width: 800px) {\n  div.clk-footer {\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  div.clk-footer-link-separator {\n    display: none;\n  }\n  div.clk-footer-div {\n    height: 75px;\n  }\n}\n\n/*\n***************************************************************\n*                        Menu Bar CSS\n***************************************************************\n*/\n\n\n.menu-button-div {\n  width:  100px;\n}\n\n.app-title-div {\n  width: 150px;\n  text-align: left;\n  color: #ffffff !important;\n}\n\n.appTitle {\n  color: #5b5b5b !important;\n}\n\n.pseudo-div {\n  width: calc(100vw - 410px);\n  padding-left: 16px;\n}\n\n.pseudo-login-div {\n  width: calc(100vw - 150px);\n  padding-left: 16px;\n}\n\n.clk-primary-menu-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: #0b0b0b;\n  opacity: 1.0;\n  height: 50px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.clk-primary-menu-bar-link-div {\n/*   width: 220px; */\n  height: 50px;\n  width: 410px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n}\n\n.clk-primary-menu-bar-login-div {\n/*   width: 220px; */\n  height: 50px;\n  width: 300px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n}\n\n.clk-primary-menu-bar-link-separator {\n  margin-left: 2px;\n  margin-right: 2px;\n  margin-top: -2px;\n  align-items: center;\n  height: 16px;\n  width: 1px;\n  background-color: #cccccc;\n}\n\n.clk-primary-menu-bar-link {\n  height: 50px;\n  width: 80px;\n  color: #bfbfbf;\n  cursor: pointer;\n  font-size: 14px;\n  margin-top: 30px;\n}\n\n.clk-primary-menu-bar-link:hover {\n  color: #fff;\n}\n\n.clk-primary-menu-bar-link-user {\n  height: 50px;\n  width: 50px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: color 0.2s ease;\n  margin-top: 0px;\n}\n\n.clk-primary-menu-bar-link-user:hover{\n  color: #bfbfbf;\n}\n\n.clk-primary-menu-bar-link-badged-user {\n  height: 50px;\n  width: 50px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: color 0.2s ease;\n  margin-top: -7px;\n}\n\n.clk-primary-menu-bar-link-badged-user:hover{\n  color: #bfbfbf;\n}\n\n.clk-primary-menu-bar-link-mobile {\n  display: none;\n  width: 0;\n  margin-left: 290px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: color 0.2s ease;\n}\n\n.clk-primary-menu-bar-link-mobile:hover {\n  color: #bfbfbf;\n}\n\n\n.clk-primary-menu-link-selected {\n  color: #bfbfbf;\n}\n\n#link-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: 10px;\n  margin: 10px;\n}\n\n#spacer {\n  flex: 1;\n}\n\n@media only screen and (max-width: 300px) {\n  div.pseudo-div {\n    width: 0px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  div.pseudo-div {\n    width: calc(100vw - 60px);\n  }\n  div.clk-primary-menu-bar-link-user {\n    display: none;\n    width: 0px;\n  }\n  div.clk-primary-menu-bar-link-badged-user {\n    display: none;\n    width: 0px;\n  }\n  div.clk-primary-menu-bar-link-mobile {\n    display: inline;\n    width: 60px\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
